function openHaitari(ele) {
  if ( jQuery(ele).parent().hasClass('open') ) {
    jQuery(ele).next().css('height', '0px');
  } else {
    jQuery(ele).next().css('height', jQuery(ele).next().children().first().outerHeight(true) + 'px');
  }

  jQuery(ele).parent().toggleClass('open');
}